import { gql } from '@apollo/client'

export default gql`
  mutation DELETE_TAG_FROM_ARTICLE($id: Int!) {
    delete_wp_posts_x_tags(where: { id: { _eq: $id } }) {
      affected_rows
    }
  }
`
